"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _async = _interopRequireDefault(require("react-select/async"));
var _core = require("../../../services/core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Address = props => {
  const {
    name
  } = props;
  const [valueField,, fieldHelper] = (0, _formik.useField)({
    name
  });
  let defaultValue = null;
  if (valueField.value) {
    defaultValue = {
      value: valueField.value,
      label: valueField.value.address
    };
  }

  // STATE
  const [selectedAsyncAddress, setSelectedAsyncAddress] = (0, _react.useState)(defaultValue); // pour voir l'adresse séléctionner par l'utilisateur
  const [addressTimer, setAddressTimer] = (0, _react.useState)({}); // Le temps de recherche d'une adresse

  /**
   * @param {string} terms
   * nous permet de récupérer des sugestions d'adresse grâce aux caractères entrée
   */

  const getSuggestions = async terms => {
    try {
      const response = await _core._Api.get(`/provider/geocoder/suggestions/${terms}/1`);
      return response.data.map(item => {
        return {
          value: item,
          label: item.address
        };
      });
    } catch (e) {
      _core._Logger.error('Erreur suggestion', '', {
        e
      });
    }
  };

  /**
   * When typing on the react-select its start this function. careful need to return a resolving promise.
   *
   * @param {string} terms
   */
  const loadAsyncOptions = async terms => {
    clearTimeout(addressTimer);
    if (terms.length < 5) {
      return;
    }
    return new Promise(resolve => {
      const timeout = setTimeout(() => {
        resolve(getSuggestions(terms));
      }, 650);
      setAddressTimer(timeout);
    });
  };

  /**
   * When clicking on the chosen address.
   *
   * @param {object} option
   */
  const onChangeAddress = option => {
    const selection = {
      ...option
    };
    setSelectedAsyncAddress(selection);
    const selectedValue = selection.value;
    if (!selectedValue) {
      return;
    }
    // external influence

    const newState = {
      address: selection.label,
      coordinate: selectedValue.coordinate
    };
    newState.postalCode = selectedValue.postcode;
    newState.city = selectedValue.city;
    newState.country = selectedValue.country;
    newState.region = selectedValue.region;
    fieldHelper.setValue(newState);
  };
  return /*#__PURE__*/_react.default.createElement(_async.default, {
    cacheOptions: true,
    loadOptions: loadAsyncOptions,
    value: selectedAsyncAddress,
    onChange: onChangeAddress,
    name: "address",
    title: "address",
    placeholder: (0, _core._translate)('registerapp_choose_address'),
    noOptionsMessage: _ref => {
      let {
        inputValue
      } = _ref;
      return !inputValue ? (0, _core._translate)('registerapp_no_options') : (0, _core._translate)('registerapp_no_options_found');
    },
    isClearable: true
  });
};
Address.propTypes = {
  onChange: _propTypes.default.func.isRequired,
  elements: _propTypes.default.arrayOf(_propTypes.default.shape({}))
};
Address.defaultProps = {
  elements: []
};
var _default = exports.default = Address;